import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('sessionToken')
      window.location.href = '/signin'
    }
    return Promise.reject(error)
  }
)

export const kbAPI = {
  // Upload file or URL to KB
  uploadFile: (data) => {
    console.log('KBAPI: Upload request:', data)
    // If data is FormData (file upload), use multipart/form-data
    if (data instanceof FormData) {
      return api.post('/api/kb/upload', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    } else {
      // If data is an object (URL upload), use application/json
      return api.post('/api/kb/upload', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
    }
  },

  // Get KB sources
  getKBSources: () => {
    console.log('KBAPI: Get KB sources request')
    return api.get('/api/kb')
  },

  // Get KB source by ID
  getKBSourceById: (id) => {
    console.log('KBAPI: Get KB source by ID request:', id)
    return api.get(`/api/kb/${id}`)
  },

  // Delete KB source
  deleteKBSource: (id) => {
    console.log('KBAPI: Delete KB source request:', id)
    return api.delete(`/api/kb/${id}`)
  },

  // Get KB status
  getKBStatus: () => {
    console.log('KBAPI: Get KB status request')
    return api.get('/api/kb/status')
  }
}

export default kbAPI
